<template>
    <section class="c-hero">
        <div class="c-hero__content">
            <div class="hero-content">
                <div
                    v-if="heroData.title"
                    class="hero-content__title"
                >
                    <component
                        :is="titleTag"
                        v-html="textReplacer(heroData.title, 'hero-title-primary')"
                    />
                </div>
                <div
                    v-if="heroData.synopsis"
                    class="hero-content__description"
                >
                    <p>
                        {{ heroData.synopsis }}
                    </p>
                </div>
                <y-button
                    v-if="heroData.custom && heroData.custom['button-link'] && !showComingSoonLabel"
                    :disabled="disableCtaBtn"
                    :tag="checkTagName()"
                    color="primary"
                    class="start-building-btn"
                    :href="heroData.custom['button-link']"
                    :to="heroData.custom['button-link']"
                >
                    {{ heroData.custom['button-title'] }}
                </y-button>
                <div
                    v-if="showComingSoonLabel"
                    class="coming-soon-label"
                >
                    <img
                        src="@/modules/api-market/assets/coming-soon.svg"
                        alt=""
                        height="64"
                        width="126"
                    >
                </div>
            </div>
        </div>
        <div class="c-hero__image-container">
            <img
                :src="imgSrc(heroData.image)"
                :alt="heroData.title"
                class="mvp-hero-img"
                :height="$mq === 'md' || $mq === 'lg' || $mq === 'xlg' ? 467 : 330"
                :width="$mq === 'md' || $mq === 'lg' || $mq === 'xlg' ? 467 : 330"
            >
        </div>
    </section>
</template>

<script >
    import { textReplacer, isLink } from '@/helpers/helpers';

    export default {
        name: 'ForPagesHero',

        /**
         *
         * @inheritDoc
         */
        props: {
            heroData: {
                type    : Object,
                required: true,
            },
            titleTag: {
                type   : String,
                default: 'h1',
            },
            disableCtaBtn      : Boolean,
            showComingSoonLabel: Boolean,
        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            textReplacer,
            isLink,

            /**
             *
             * check tag name
             *
             * @returns {string}
             */
            checkTagName() {
                if (this.disableCtaBtn) {
                    return 'button';
                }
                return isLink(this.heroData.custom['button-link']) ? 'a' : 'router-link';
            },
        },
    };

</script>

<style lang="scss" src="./hero.scss"/>
